import { Button } from '@/components/ui/daisy';
import { CheckIcon } from '@heroicons/react/24/outline';

type AnswerConfirmEditProps = {
  onConfirm: () => void;
};

export default function AnswerConfirmEdit({
  onConfirm,
}: AnswerConfirmEditProps) {
  return (
    <Button
      type="button"
      size="xs"
      variant="ghost"
      shape="circle"
      onMouseDown={e => e.preventDefault()}
      onClick={onConfirm}
    >
      <CheckIcon className="size-4.5" />
    </Button>
  );
}
